import { Predictions } from '@/app/(pages)/(homePage)/components/MobileAttractionsSearchInput';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import { deslugify } from '@/utils/slugify';
import { faLocation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { count } from 'console';
import Image from 'next/image';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import TicketColor from '../icons/TicketColor';
import ImageLoading from '../ImageLoading';
import LocationsPin from '../icons/LocationsPin';
import DestinationColor from '../icons/DestinationColor';
import NextLink from '../NextLink';
import slugify from 'slugify';
import { slugifyOptions } from '@/utils/slugifyOptions';
import { autoComplete } from '@/actions/places/autoComplete';
import { autoComplete as activitiesAutoComplete } from '@/actions/activities/autoComplete';
import useNextRouter from '@/hooks/useNextRouter';

export default function SearchInput({ type = 'webbed', ...props }: {
    type?: 'google' | 'webbed' | 'attractions',
    hasError?: boolean,
    onFocus?: () => void;
    setSelectedCity: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
    , selectedCity: {
        name: string;
        id: string;
        country: string;
    }
}) {
    const searchInputComponents = {
        google: GoogleSearchInput,
        webbed: WebbedSearchInput,
        attractions: ViatorSearchInput
    } as const;

    const SearchComponent = searchInputComponents[type];

    if (!SearchComponent) {
        throw new Error(`Invalid search input type: ${type}`);
    }

    return <SearchComponent {...props} />;
}

function WebbedSearchInput({ hasError, setSelectedCity, selectedCity, onFocus }: {
    hasError?: boolean,
    onFocus?: () => void;
    setSelectedCity: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
    , selectedCity: {
        name: string;
        id: string;
        country: string;
    }
}) {
    console.log();
    
    const [cityError, setCityError] = useState(false);
    const [isGettingCities, setIsGettingCities] = useState(false);
    const [city, setCity] = useState(selectedCity.name);
    const [showCities, setShowCities] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [predictions, setPredictions] = useState<
        { id: string; name: string, country: string }[]
    >([]);


    const { params, mainParams } = useSetSearchParams();
    const { country: countryParams } = mainParams;
    const country = countryParams?.[0]
    const cityParam = countryParams?.[1]
    const cityModal = useOutsideClick(() => {
        setShowCities(false);
    });

    const get = async (city: string) => {
        setIsGettingCities(true);
        try {

            const res = await autoComplete(city.split(', ')[1] || city);

            const { result } = await JSON.parse(res)
            console.log({ result });

            const cityNames = result.data.cities?.map(
                (prediction: any, index: number) => {
                    return {
                        ...prediction,
                        id: index,
                    };
                },
            );
            setIsGettingCities(false);
            setPredictions(cityNames || []);
        } catch (err) {
            setIsGettingCities(false);
            setFetchError("Something went wrong!");
        }
    };

    useEffect(() => {
        setFetchError("");
        if (city) {
            setIsGettingCities(true);
        }

        const getData = setTimeout(() => {
            if (city && city.length > 0) {
                get(city);
            }
        }, 400);

        return () => clearTimeout(getData);
    }, [city]);

    useEffect(() => {
        if (cityParam || country) {
            setCity(`${deslugify(country)} ${cityParam ? `, ${deslugify(cityParam)}` : ''}` as string);
        }
    }, [cityParam, country]);

    return (
        <>
            <input
                ref={cityModal}
                placeholder={'Enter your destination'}
                value={
                    city
                }
                className={`${hasError ? "border-rose-500" : "border"} 
                   peer relative border-0 h-full w-full pl-0 pr-2.5 py-1 text-neutral-800 font-normal
                    placeholder:text-neutral-500 placeholder:font-normal placeholder:text-sm 
             `}
                onChange={async (e) => {
                    setShowCities(true)
                    setCity(e.target.value);
                    setSelectedCity({
                        name: "",
                        id: "",
                        country: "",
                    });
                }}
                onClick={() => {
                    setShowCities(true)
                }}
                onFocus={() => {
                    onFocus && onFocus()
                    setShowCities(true);
                }}
                type="text"
            />

            {cityError && (
                <p className="ps-1 pt-1 text-sm font-normal text-red-600">
                    Please choose your destination.
                </p>
            )}

            {isGettingCities && city.length > 0 ? (
                <div
                    className="absolute bottom-0 z-50  flex h-0 w-full min-w-fit
                  translate-y-[96%] overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all 
                   duration-300 peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100"
                >
                    <div className="flex w-full flex-col gap-8 pt-1">
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : predictions.length > 0 && city.length > 0 ? (
                <div
                    className={`${showCities
                        ? "pointer-events-auto translate-y-full opacity-100"
                        : "pointer-events-none translate-y-[96%] opacity-0"
                        } 
              absolute bottom-0 z-50  flex text-base font-normal h-fit w-full min-w-fit flex-col
              items-stretch  overflow-hidden rounded-lg border bg-white px-2 
               py-2 shadow transition-all duration-300  
                `}
                >
                    {predictions?.map((item) => (
                        <div
                            onTouchStart={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                setShowCities(false);
                                setCityError(false);
                                setSelectedCity({
                                    name: item.name.split(",")[0],
                                    id: item.id,
                                    country: item.country
                                    ,
                                });
                                setCity(item.name.split(",")[0]);
                            }}
                            onClick={() => {
                                setShowCities(false);
                                setCityError(false);
                                setSelectedCity({
                                    name: item.name.split(",")[0],
                                    id: item.id,
                                    country: item.country
                                    ,
                                });
                                setCity(item.name.split(",")[0]);
                            }}
                            className="group grid cursor-pointer grid-cols-[30px,_1fr] place-items-start items-center gap-1 rounded-xl 
                  px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                            key={item.id}
                        >
                            <FontAwesomeIcon icon={faLocation} className="w-5 justify-self-center text-gray-600" />
                            <div className="flex flex-col  gap-1">
                                <p className="font-semibold capitalize text-base text-[#202020]">
                                    {item.name.toLowerCase()}
                                </p>
                                <span className="text-xs capitalize font-normal text-gray-600">
                                    {item.country}{" "}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                city.length > 0 && (
                    <div
                        className="absolute bottom-0 z-50 hidden h-0 w-full min-w-fit translate-y-[96%]
                        overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all duration-300 
                         peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100 lg:flex"
                    >
                        <div
                            className="group flex w-full max-w-full cursor-pointer items-center gap-3 
                          transition-colors duration-200 hover:text-emerald-700 "
                        >
                            {fetchError ? (
                                <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                    <p className="text-orange-500">{fetchError}</p>

                                    <Image
                                        className="w-32"
                                        src={"https://assets.bamboo.travel/wrong.svg"}
                                        width={300}
                                        height={300}
                                        alt="Nothing Found"
                                    />
                                </div>
                            ) : (
                                city.length > 0 && (
                                    <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                        <p className='text-neutral-700 text-sm'>nothing was found!</p>

                                        <Image
                                            className="w-16"
                                            src={"https://assets.bamboo.travel/looking.svg"}
                                            width={300}
                                            height={300}
                                            alt="Nothing Found"
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )
            )}
        </>
    );
}


function GoogleSearchInput({ hasError, setSelectedCity, selectedCity, onFocus }: {
    hasError?: boolean,
    onFocus?: () => void;
    setSelectedCity: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
    , selectedCity: {
        name: string;
        id: string;
        country: string;
    }
}) {
    const [cityError, setCityError] = useState(false);
    const [isGettingCities, setIsGettingCities] = useState(false);
    const [city, setCity] = useState("");
    const [showCities, setShowCities] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [predictions, setPredictions] = useState<
        { id: string; name: string }[]
    >([]);


    const { params, } = useSetSearchParams();
    const { city: cityParam, } = params;

    const cityModal = useOutsideClick(() => {
        setShowCities(false);
    });

    const get = async (city: string) => {
        setIsGettingCities(true);
        try {
            const res = await fetch(`/api/places?city=${city}`);

            const { data } = await res.json();

            const cityNames = data?.map(
                (prediction: { name: string; id: string }) => {
                    return {
                        name: prediction.name,
                        id: prediction.id,
                    };
                },
            );

            setIsGettingCities(false);
            setPredictions(cityNames || []);
        } catch (err) {
            setIsGettingCities(false);

            setFetchError("Something went wrong!");
        }
    };

    useEffect(() => {
        setFetchError("");
        if (city) {
            setIsGettingCities(true);
        }

        const getData = setTimeout(() => {
            if (city && city.length > 0) {
                get(city);
            }
        }, 400);

        return () => clearTimeout(getData);
    }, [city]);

    useEffect(() => {
        if (cityParam) {
            setCity(cityParam as string);
        }
    }, [cityParam]);

    useEffect(() => {
        if (selectedCity.id) {
            setCity(selectedCity.name)
        }
    }, [selectedCity?.id])

    return (
        <>
            <input
                ref={cityModal}
                placeholder={'Enter your destination'}
                value={
                    city 
                }
                className={`${hasError ? "border-rose-500" : "border"} 
                   peer relative capitalize border-0 h-full w-full pl-0 pr-2.5 py-1 text-neutral-800 font-normal
                    placeholder:text-neutral-500 placeholder:font-normal placeholder:text-sm 
             `}
                onChange={async (e) => {
                    setShowCities(true)
                    setCity(e.target.value);
                    setSelectedCity({
                        name: "",
                        id: "",
                        country: "",
                    });
                }}
                onClick={() => {
                    setShowCities(true)
                }}
                onFocus={() => {
                    onFocus && onFocus()
                    setShowCities(true);
                }}
                type="text"
            />
            {cityError && (
                <p className="ps-1 pt-1 text-sm font-normal text-red-600">
                    Please choose your destination.
                </p>
            )}

            {isGettingCities && city.length > 0 ? (
                <div
                    className="absolute bottom-0 z-50  flex h-0 w-full min-w-fit
                  translate-y-[96%] overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all 
                   duration-300 peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100"
                >
                    <div className="flex w-full flex-col gap-8 pt-1">
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : predictions.length > 0 && city.length > 0 ? (
                <div
                    className={`${showCities
                        ? "pointer-events-auto translate-y-full opacity-100"
                        : "pointer-events-none translate-y-[96%] opacity-0"
                        } 
              absolute bottom-0 z-50  flex text-base font-normal h-fit w-full min-w-fit flex-col
              items-stretch  overflow-hidden rounded-lg border bg-white px-2 
               py-2 shadow transition-all duration-300  
                `}
                >
                    {predictions?.map((item) => (
                        <div
                            onTouchStart={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                setShowCities(false);
                                setCityError(false);
                                setSelectedCity({
                                    name: item.name.split(",")[0],
                                    id: item.id,
                                    country:
                                        item.name.split(", ")[item.name.split(", ").length - 1],
                                });
                                setCity(item.name.split(",")[0]);
                            }}
                            onClick={() => {
                                setShowCities(false);
                                setCityError(false);
                                setSelectedCity({
                                    name: item.name.split(",")[0],
                                    id: item.id,
                                    country:
                                        item.name.split(", ")[item.name.split(", ").length - 1],
                                });
                                setCity(item.name.split(",")[0]);
                            }}
                            className="group grid cursor-pointer grid-cols-[30px,_1fr] place-items-start items-start gap-1 rounded-xl 
                  px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                            key={item.id}
                        >
                            <FontAwesomeIcon icon={faLocation} className="w-5 justify-self-center text-gray-600" />
                            <div className="flex flex-col  gap-1">
                                <p className="font-semibold text-base text-[#202020]">
                                    {" "}
                                    {item.name.split(", ")[0]}{" "}
                                </p>
                                <span className="text-xs font-normal text-gray-600">
                                    {item.name.split(", ")[1] !== item.name.split(", ")[item.name.split(", ").length - 1] && item.name.split(", ")[1]}{" "}{item.name.split(", ")[item.name.split(", ").length - 1]}{" "}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                city.length > 0 && (
                    <div
                        className="absolute bottom-0 z-50 hidden h-0 w-full min-w-fit translate-y-[96%]
                        overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all duration-300 
                         peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100 lg:flex"
                    >
                        <div
                            className="group flex w-full max-w-full cursor-pointer items-center gap-3 
                          transition-colors duration-200 hover:text-emerald-700 "
                        >
                            {fetchError ? (
                                <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                    <p className="text-orange-500">{fetchError}</p>

                                    <Image
                                        className="w-32"
                                        src={"https://assets.bamboo.travel/wrong.svg"}
                                        width={300}
                                        height={300}
                                        alt="Nothing Found"
                                    />
                                </div>
                            ) : (
                                city.length > 0 && (
                                    <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                        <p className='text-neutral-700 text-sm'>nothing was found!</p>

                                        <Image
                                            className="w-16"
                                            src={"https://assets.bamboo.travel/looking.svg"}
                                            width={300}
                                            height={300}
                                            alt="Nothing Found"
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )
            )}
        </>
    );
}


function ViatorSearchInput({ hasError, setSelectedCity, selectedCity, onFocus }: {
    hasError?: boolean,
    onFocus?: () => void;
    setSelectedCity: Dispatch<SetStateAction<{
        name: string;
        id: string;
        country: string;
    }>>
    , selectedCity: {
        name: string;
        id: string;
        country: string;
    }
}) {
    const [cityError, setCityError] = useState(false);
    const [isGettingCities, setIsGettingCities] = useState(false);
    const [city, setCity] = useState("");
    const [showCities, setShowCities] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [predictions, setPredictions] = useState<Predictions>({
        attractions: [],
        destinations: [],
        products: []
    });

    const { push } = useNextRouter()

    const { params, } = useSetSearchParams();
    const { city: cityParam, } = params;

    const cityModal = useOutsideClick(() => {
        setShowCities(false);
    });

    const get = async (city: string) => {
        setIsGettingCities(true);
        try {
            const res = await activitiesAutoComplete(city);

            const { result } = JSON.parse(res);

            // console.log({ result });

            setIsGettingCities(false);
            if (result.data) {
                setPredictions(result.data);
            }
        } catch (err) {
            setIsGettingCities(false);

            setFetchError("Something went wrong!");
        }
    };


    useEffect(() => {
        setFetchError("");
        if (city) {
            setIsGettingCities(true);
        }

        const getData = setTimeout(() => {
            if (city && city.length > 0) {
                get(city);
            }
        }, 400);

        return () => clearTimeout(getData);
    }, [city]);

    useEffect(() => {
        if (cityParam) {
            setCity(cityParam as string);
        }
    }, [cityParam]);



    return (
        <>
            <input
                ref={cityModal}
                placeholder={'Enter your destination'}
                value={
                    city + (selectedCity.country ? `, ${selectedCity.country}` : "")
                }
                className={`${hasError ? "border-rose-500" : "border"} 
                   peer relative capitalize border-0 h-full w-full pl-0 pr-2.5 py-1 text-neutral-800 font-normal
                    placeholder:text-neutral-500 placeholder:font-normal placeholder:text-sm 
             `}
                onChange={async (e) => {
                    setShowCities(true)
                    setCity(e.target.value);
                    setSelectedCity({
                        name: "",
                        id: "",
                        country: "",
                    });
                }}
                onClick={() => {
                    setShowCities(true)
                }}
                onFocus={() => {
                    onFocus && onFocus()
                    setShowCities(true);
                }}
                type="text"
            />
            {cityError && (
                <p className="ps-1 pt-1 text-sm font-normal text-red-600">
                    Please choose your destination.
                </p>
            )}

            {isGettingCities && city.length > 0 ? (
                <div
                    className="absolute bottom-0 z-50  flex h-0 w-full min-w-fit
                  translate-y-[96%] overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all 
                   duration-300 peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100"
                >
                    <div className="flex w-full flex-col gap-8 pt-1">
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                        <div className="flex w-full items-center gap-3">
                            <div className="h-8 w-8 animate-pulse overflow-hidden rounded-md border bg-slate-200 shadow-sm"></div>
                            <div className="flex flex-col gap-2">
                                <div className="h-3 w-36 animate-pulse rounded bg-slate-200 "></div>
                                <div className="h-3 w-24 animate-pulse rounded bg-slate-200 "></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : Object.values(predictions)?.flat().length > 0 && city.length > 0 ? (
                <div
                    className={`${showCities
                        ? "pointer-events-auto translate-y-full opacity-100"
                        : "pointer-events-none translate-y-[96%] opacity-0"
                        } 
              absolute bottom-0 z-50   text-base font-normal h-fit w-full min-w-fit 
              items-stretch  overflow-y-auto rounded-lg border bg-white px-2 max-h-[300px]
               py-2 shadow transition-all duration-300  flex flex-col gap-2
                `}
                >
                    {predictions.products.length > 0 && (
                        <div className='grid grid-cols-2'>
                            <div className='text-xs col-span-2 font-semibold text-neutral-700 mb-2'>Activities</div>
                            {predictions.products.map((item, index) => (
                                <NextLink
                                    key={index}
                                    href={`/activities/${item.destination.countrySlug}/${item.destination.citySlug}/${item.slug}`}
                                    onTouchEnd={(event) => {
                                        event.preventDefault();
                                        setShowCities(false);
                                        push(`/activities/${item.destination.countrySlug}/${item.destination.citySlug}/${item.slug}`)
                                        setCityError(false);
                                        setSelectedCity({
                                            name: item.title,
                                            id: index.toString(),
                                            country: '',
                                        });
                                        setCity(item.title);
                                    }}
                                    className="group grid cursor-pointer grid-cols-[64px,_1fr] gap-2 place-items-start items-start rounded-xl px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                                >
                                    <div className='size-16 rounded-2xl overflow-hidden'>
                                        {(item.images && item.images[0] && item.images[0].url) ? (
                                            <ImageLoading src={item.images[0]?.url}
                                                width={100}
                                                height={100}
                                                alt={item.title} className="w-full h-full object-cover" />
                                        ) : <div className='flex size-16 items-center bg-pastel-purple rounded-2xl justify-center'>
                                            <TicketColor className='w-6' />
                                        </div>}
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <p className="font-semibold text-sm text-neutral-800">{item.title}</p>
                                    </div>
                                </NextLink>
                            ))}
                        </div>
                    )}

                    {predictions.destinations.flat().length > 0 && (
                        <div className='grid grid-cols-2'>
                            <div className='text-xs col-span-2 font-semibold text-neutral-700 mb-2 mt-4'>Destinations</div>
                            {predictions.destinations.flat().map((item, index) => (
                                <NextLink
                                    key={index}
                                    href={`/attractions/${item.countrySlug}/${item.type === 'CITY' ? item.citySlug : ''}`}
                                    onTouchEnd={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        push(`/attractions/${item.countrySlug}/${item.type === 'CITY' ? item.citySlug : ''}`)
                                        setShowCities(false);
                                        setCityError(false);
                                        setSelectedCity({
                                            name: item.name,
                                            id: item.destinationId,
                                            country: item.type,
                                        });
                                        setCity(item.name);
                                    }}
                                    className="group grid cursor-pointer grid-cols-[64px,_1fr] gap-2 place-items-start items-start rounded-xl px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                                >
                                    <div className='flex size-16 items-center bg-pastel-red rounded-2xl justify-center'>
                                        <LocationsPin className='w-6' />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <p className="font-semibold text-sm text-neutral-800">{item.name}</p>
                                        <span className="text-xs font-normal text-gray-600">{item.country}</span>
                                    </div>
                                </NextLink>
                            ))}
                        </div>
                    )}

                    {predictions.attractions.length > 0 && (
                        <div className='grid grid-cols-2'>
                            <div className='text-xs col-span-2 font-semibold text-neutral-700 mb-2 mt-4'>Attractions</div>
                            {predictions.attractions.map((item, index) => (
                                <NextLink
                                    key={index}
                                    href={`/attractions/${item.destination.countrySlug || 'country'}/${item.destination.citySlug || 'region'}/${item.slug}`}
                                    onTouchEnd={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        push(`/attractions/${item.destination.countrySlug || 'country'}/${item.destination.citySlug || 'region'}/${item.slug}`)
                                        setShowCities(false);
                                        setCityError(false);
                                        setSelectedCity({
                                            name: item.name,
                                            id: item.destinationId,
                                            country: '',
                                        });
                                        setCity(item.name);
                                    }}
                                    className="group grid cursor-pointer grid-cols-[64px,_1fr] gap-2 place-items-start items-start rounded-xl px-1 py-2 transition-colors duration-200 hover:bg-gray-100 hover:text-emerald-700 lg:w-full"
                                >
                                    <div className='flex size-16 items-center bg-pastel-green rounded-2xl justify-center'>
                                        <DestinationColor className='w-6' />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <p className="font-semibold text-sm text-neutral-800">{item.name}</p>
                                    </div>
                                </NextLink>
                            ))}
                        </div>
                    )}
                </div>
            ) : (
                city.length > 0 && (
                    <div
                        className="absolute bottom-0 z-50 hidden h-0 w-full min-w-fit translate-y-[96%]
                        overflow-hidden rounded-lg border bg-white p-3 opacity-0 shadow transition-all duration-300 
                         peer-focus:h-fit peer-focus:translate-y-full peer-focus:opacity-100 lg:flex"
                    >
                        <div
                            className="group flex w-full max-w-full cursor-pointer items-center gap-3 
                          transition-colors duration-200 hover:text-emerald-700 "
                        >
                            {fetchError ? (
                                <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                    <p className="text-orange-500">{fetchError}</p>

                                    <Image
                                        className="w-32"
                                        src={"https://assets.bamboo.travel/wrong.svg"}
                                        width={300}
                                        height={300}
                                        alt="Nothing Found"
                                    />
                                </div>
                            ) : (
                                city.length > 0 && (
                                    <div className="flex w-full flex-col items-center justify-center gap-4 ">
                                        <p className='text-neutral-700 text-sm'>nothing was found!</p>

                                        <Image
                                            className="w-16"
                                            src={"https://assets.bamboo.travel/looking.svg"}
                                            width={300}
                                            height={300}
                                            alt="Nothing Found"
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )
            )}
        </>
    );
}